module.exports = __webpack_public_path__ + "static/media/uppdate.cb225b14.svg";